const Breadcrumb = [
    {
        id: "breadcrumb-1",
        slug: "/referral-program/",
        links: [{ id: "breadcrumb-1.1", link: null, text: "REFERRAL PROGRAM" }]
    },
    {
        id:'contact-1',
        slug:'/contact-us/',
        links: [{ id: "contact-1.1", link: null, text: "CONTACT US" }]
    },
    {
        id:'about-1',
        slug:'/about-us/',
        links: [{ id: "about-1.1", links: null, text: "ABOUT"}]
    },
    {
        id:'Payment Plan',
        slug:'/payment-plan/',
        links: [{ id: "payment-plan-1.1", links: null, text: "PAYMENT PLAN"}]
    },
    {
        id:'New Tech',
        slug:'/new-technologies/',
        links: [{ id: "new Tech-3.1", links: null, text: 'NEW TECHNOLOGIES'}]
    },  {
        id:'Covid',
        slug:'/how-we-can-reduce-the-spread-of-corona-virus-together/',
        links: [{ id: "Covid-3.1", links: null, text: 'HOW WE CAN REDUCE THE SPREAD OF CORONA VIRUS TOGETHER'}]
    },
    {
        id:'skye',
        slug:'/get-painless-dental-treatment-at-skye/',
        links: [{ id: "Covid-3.1", links: null, text: 'GET PAINLESS DENTAL TREATMENT AT SKYE'}]
    },   {
        id:'sandhurst',
        slug:'/get-the-best-dental-care-at-sandhurst/',
        links: [{ id: "Covid-3.1", links: null, text: 'GET THE BEST DENTAL CARE AT SANDHURST'}]
    },  {
        id:'patterson-lake',
        slug:'/affordable-dental-services-at-patterson-lakes/',
        links: [{ id: "Covid-3.1", links: null, text: 'AFFORDABLE DENTAL SERVICES AT PATTERSON LAKES'}]
    }, {
        id:'carbourne-west',
        slug:'/we-are-your-go-to-dentist-in-cranbourne-west/',
        links: [{ id: "Covid-3.1", links: null, text: 'WE ARE YOUR GO-TO DENTIST IN CRANBOURNE WEST'}]
    },
    {
        id:'frankston-north',
        slug:'/looking-for-a-dentist-in-frankston-north/',
        links: [{ id: "Covid-3.1", links: null, text: 'LOOKING FOR A DENTIST IN FRANKSTON NORTH?'}]
    },  {
        id:'seaford',
        slug:'/find-the-best-dentist-in-seaford/',
        links: [{ id: "Covid-3.1", links: null, text: 'FIND THE BEST DENTIST IN SEAFORD'}]
    }, {
        id:'lyndhurst',
        slug:'/get-all-your-dental-needs-handled-in-lyndhurst/',
        links: [{ id: "Covid-3.1", links: null, text: 'GET ALL YOUR DENTAL NEEDS HANDLED IN LYNDHURST'}]
    }, {
        id:'langwarrin',
        slug:'/affordable-dental-services-at-langwarrin/',
        links: [{ id: "Covid-3.1", links: null, text: 'AFFORDABLE DENTAL SERVICES AT LANGWARRIN'}]
    }
];


export default Breadcrumb;